<template>
  <div class="jobs">
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title"></div>
    <div class="lead-1 popup-subtitle" v-html="popup.sections.main.fields.value.subTitle"></div>
    <div class="paragraph-1">
      <a class="text-highlight" :href="popup.sections.main.fields.value.link" target="_blank">https://hmq.ch/jobs</a>
      <br/>
      <br/>
      <div class="paragraph-1" v-html="popup.sections.main.fields.value.text"></div>
      <a href="mailto:info@seu.ch" class="paragraph-1-link" v-html="popup.sections.main.fields.value.subTitle"></a>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Jobs',
  computed: {
    popup() {
      return require(`../../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/jobs`).default;
    }
  },

}
</script>

<style lang="scss">
@import "Jobs.scss";
</style>
